enum Actions {
  //theme
  THEME_BODY_CLASSNAME_ADD = "THEME_BODY_CLASSNAME_ADD",
  THEME_BODY_BACKGROUND_SET = "THEME_BODY_BACKGROUND_SET",
  THEME_ELEMENT_CLASSNAME_TOGGLE = "THEME_ELEMENT_CLASSNAME_TOGGLE",
  THEME_BODY_CLASSNAME_REMOVE = "THEME_BODY_CLASSNAME_REMOVE",
  THEME_LIVECHAT_REMOVE = "THEME_LIVECHAT_REMOVE",
  THEME_LIVECHAT_INIT = "THEME_LIVECHAT_INIT",
  THEME_BODY_ATTRIBUTE_ADD = "THEME_BODY_ATTRIBUTE_ADD",
  THEME_BODY_ATTRIBUTE_REMOVE = "THEME_BODY_ATTRIBUTE_REMOVE",
  THEME_CLASSNAME_ADD = "THEME_CLASSNAME_ADD",
  THEME_WHITE_LABEL_LOAD = "THEME_WHITE_LABEL_LOAD",
  //manager
  MANAGER_COMPANY_ACCOUNTS_LOAD = "MANAGER_COMPANY_ACCOUNTS_LOAD",
  MANAGER_COMPANY_ALERTS_LOAD = "MANAGER_COMPANY_ALERTS_LOAD",
  MANAGER_COMPANY_ACCOUNTS_CREATE = "MANAGER_COMPANY_ACCOUNTS_CREATE",
  MANAGER_COMPANY_ACCOUNTS_RESET = "MANAGER_COMPANY_ACCOUNTS_RESET",
  MANAGER_COMPANY_ACCOUNT_SET_DEFAULT = "MANAGER_COMPANY_ACCOUNT_SET_DEFAULT",
  MANAGER_COMPANY_ACCOUNT_REFRESH_SELECTED = "MANAGER_COMPANY_ACCOUNT_REFRESH_SELECTED",
  MANAGER_COMPANY_ACCOUNT_DOWNLOAD_RL = "MANAGER_COMPANY_ACCOUNT_DOWNLOAD_RL",
  MANAGER_COMPANY_STATISTIC_LOAD = "MANAGER_COMPANY_STATISTIC_LOAD",
  MANAGER_COMPANY_WHITE_LABEL_LOAD = "MANAGER_COMPANY_WHITE_LABEL_LOAD",
  MANAGER_COMPANY_WHITE_LABEL_UPDATE = "MANAGER_COMPANY_WHITE_LABEL_UPDATE",
  MANAGER_COMPANY_WHITE_LABEL_IMAGE_UPLOAD = "MANAGER_COMPANY_WHITE_LABEL_IMAGE_UPLOAD",
  MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_LOAD = "MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_LOAD",
  MANAGER_COMPANY_WHITE_LABEL_DOCUMENT_UPDATE = "MANAGER_COMPANY_WHITE_LABEL_DOCUMENT_UPDATE",
  MANAGER_COMPANY_WHITE_LABEL_DOCUMENT_IMAGE_UPLOAD = "MANAGER_COMPANY_WHITE_LABEL_DOCUMENT_IMAGE_UPLOAD",
  MANAGER_COMPANY_STATISTIC_TRANSACTION_VOLUME_LOAD = "MANAGER_COMPANY_STATISTIC_TRANSACTION_VOLUME_LOAD",
  MANAGER_COMPANY_STATISTIC_ACCOUNTS_VOLUME_LOAD = "MANAGER_COMPANY_STATISTIC_ACCOUNTS_VOLUME_LOAD",
  MANAGER_COMPLIANCE_TRACKINGS_LOAD = "MANAGER_COMPLIANCE_TRACKINGS_LOAD",
  MANAGER_ANNOUNCEMENTS_LOAD = "MANAGER_ANNOUNCEMENTS_LOAD",
  MANAGER_AFFILIATE_COMPANIES_LOAD = "MANAGER_AFFILIATE_COMPANIES_LOAD",
  MANAGER_WHITE_LABELED_COMPANIES_LOAD = "MANAGER_WHITE_LABELED_COMPANIES_LOAD",
  MANAGER_COMPANY_PRODUCTS_LOAD = "MANAGER_COMPANY_PRODUCTS_LOAD",
  MANAGER_COMPANY_WALLETS_LOAD = "MANAGER_COMPANY_WALLETS_LOAD",
  MANAGER_COMPANY_WALLETS_CREATE = "MANAGER_COMPANY_WALLETS_CREATE",
  MANAGER_COMPANY_WALLETS_DELETE = "MANAGER_COMPANY_WALLETS_DELETE",
  MANAGER_COMPANY_PRODUCTS_VIEW = "MANAGER_COMPANY_PRODUCTS_VIEW",
  MANAGER_COMPANY_PRODUCTS_CREATE = "MANAGER_COMPANY_PRODUCTS_CREATE",
  MANAGER_COMPANY_PRODUCTS_UPDATE = "MANAGER_COMPANY_PRODUCTS_UPDATE",
  MANAGER_COMPANY_PRODUCTS_UPDATE_IMAGE = "MANAGER_COMPANY_PRODUCTS_UPDATE_IMAGE",
  MANAGER_PORTAL_SERVICES_SIGN_IN = "MANAGER_PORTAL_SERVICES_SIGN_IN",
  MANAGER_PORTAL_SERVICES_SIGN_UP_COMPANY = "MANAGER_PORTAL_SERVICES_SIGN_UP_COMPANY",
  MANAGER_PORTAL_SERVICES_SIGN_UP_EMPLOYEE = "MANAGER_PORTAL_SERVICES_SIGN_UP_EMPLOYEE",
  MANAGER_PORTAL_SERVICES_AUTO_TRANSFER_CONFIGURE = "MANAGER_PORTAL_SERVICES_AUTO_TRANSFER_CONFIGURE",
  MANAGER_PORTAL_SERVICES_AUTO_TRANSFER_REMOVE = "MANAGER_PORTAL_SERVICES_AUTO_TRANSFER_REMOVE",
  MANAGER_PORTAL_SERVICES_LOAD_REMOTE_ACCOUNTS = "MANAGER_PORTAL_SERVICES_LOAD_REMOTE_ACCOUNTS",
  MANAGER_PSP_PORTAL_USER_SIGN_UP = "MANAGER_PSP_PORTAL_USER_SIGN_UP",
  MANAGER_PSP_PORTAL_USER_UPSERT_ACCOUNTS = "MANAGER_PSP_PORTAL_USER_UPSERT_ACCOUNTS",
  MANAGER_PSP_PORTAL_ACCOUNTS_LOAD = "MANAGER_PSP_PORTAL_ACCOUNTS_LOAD",
  MANAGER_PSP_PORTAL_USER_REVOKE_TOKEN = "MANAGER_PSP_PORTAL_USER_REVOKE_TOKEN",
  MANAGER_OPENAI_CHAT_MODAL = "MANAGER_OPENAI_CHAT_MODAL",
  //admin
  ADMIN_TRANSACTION_STATISTIC_LOAD = "ADMIN_TRANSACTION_STATISTIC_LOAD",
  ADMIN_TIMELINE_ENTITY_CLASSES_LOAD = "ADMIN_TIMELINE_ENTITY_CLASSES_LOAD",
  ADMIN_USER_STATISTIC_LOAD = "ADMIN_USER_STATISTIC_LOAD",
  ADMIN_USERS_LOAD = "ADMIN_USERS_LOAD",
  ADMIN_COMPANIES_LOAD = "ADMIN_COMPANIES_LOAD",
  ADMIN_COMPANY_PROFILE_REQUEST = "ADMIN_COMPANY_PROFILE_REQUEST",
  ADMIN_COMPANY_BY_ZOHO_ID_REQUEST = "ADMIN_COMPANY_BY_ZOHO_ID_REQUEST",
  ADMIN_COMPANY_EMPLOYEES_REQUEST = "ADMIN_COMPANY_EMPLOYEES_REQUEST",
  ADMIN_COMPANY_EMPLOYEE_COMPLIANCES_REQUEST = "ADMIN_COMPANY_EMPLOYEE_COMPLIANCES_REQUEST",
  ADMIN_COMPANY_COMPLIANCES_REQUEST = "ADMIN_COMPANY_COMPLIANCES_REQUEST",
  ADMIN_COMPANY_UPDATE = "ADMIN_COMPANY_UPDATE",
  ADMIN_COMPANY_EMPLOYEE_UPDATE = "ADMIN_COMPANY_EMPLOYEE_UPDATE",
  ADMIN_COMPANY_PAYMENT_SERVICES_REQUEST = "ADMIN_COMPANY_PAYMENT_SERVICES_REQUEST",
  ADMIN_COMPANY_PAYMENT_SERVICE_ONBOARDING_TRANSITIONS_REQUEST = "ADMIN_COMPANY_PAYMENT_SERVICE_ONBOARDING_TRANSITIONS_REQUEST",
  ADMIN_COMPANY_PAYMENT_SERVICE_APPLY_ONBOARDING_STAGE_REQUEST = "ADMIN_COMPANY_PAYMENT_SERVICE_APPLY_ONBOARDING_STAGE_REQUEST",
  ADMIN_COMPANY_PAYMENT_SERVICE_UPDATE_FIELDS_ONBOARDING_STAGE = "ADMIN_COMPANY_PAYMENT_SERVICE_UPDATE_FIELDS_ONBOARDING_STAGE",
  ADMIN_COMPANY_PAYMENT_SERVICE_ONBOARD_REQUEST = "ADMIN_COMPANY_PAYMENT_SERVICE_ONBOARD_REQUEST",
  ADMIN_BANK_ACCOUNTS_LOAD = "ADMIN_BANK_ACCOUNTS_LOAD",
  ADMIN_BANK_ACCOUNT_INTEGRITIES_LOAD = "ADMIN_BANK_ACCOUNT_INTEGRITIES_LOAD",
  ADMIN_BANK_ACCOUNT_INTEGRITIES_RUN = "ADMIN_BANK_ACCOUNT_INTEGRITIES_RUN",
  ADMIN_ANNOUNCEMENTS_LOAD = "ADMIN_ANNOUNCEMENTS_LOAD",
  ADMIN_ANNOUNCEMENTS_VIEW = "ADMIN_ANNOUNCEMENTS_VIEW",
  ADMIN_ANNOUNCEMENTS_CREATE = "ADMIN_ANNOUNCEMENTS_CREATE",
  ADMIN_ANNOUNCEMENTS_UPDATE = "ADMIN_ANNOUNCEMENTS_UPDATE",
  ADMIN_ANNOUNCEMENTS_DELETE = "ADMIN_ANNOUNCEMENTS_DELETE",
  ADMIN_SYSTEM_OVERVIEW_LOAD = "ADMIN_SYSTEM_OVERVIEW_LOAD",
  ADMIN_SYSTEM_OVERVIEW_START = "ADMIN_SYSTEM_OVERVIEW_START",
  ADMIN_SETTINGS_LOAD = "ADMIN_SETTINGS_LOAD",
  ADMIN_SETTINGS_UPSERT = "ADMIN_SETTINGS_UPSERT",
  ADMIN_SYSTEM_STATISTIC_TRANSACTION_VOLUME_LOAD = "ADMIN_SYSTEM_STATISTIC_TRANSACTION_VOLUME_LOAD",
  //common/project/bootstrap
  COMMON_PROJECT_BOOTSTRAP_BEFORE_ROUTE = "COMMON_PROJECT_BOOTSTRAP_BEFORE_ROUTE",
  COMMON_PROJECT_BOOTSTRAP_AFTER_ROUTE = "COMMON_PROJECT_BOOTSTRAP_AFTER_ROUTE",
  COMMON_PROJECT_BOOTSTRAP_DATA_LIFECYCLE = "COMMON_PROJECT_BOOTSTRAP_DATA_LIFECYCLE",
  COMMON_PROJECT_BOOTSTRAP_ACTIONS_LIFECYCLE = "COMMON_PROJECT_BOOTSTRAP_ACTIONS_LIFECYCLE",
  //common/notifications
  COMMON_NOTIFICATIONS_LOAD = "COMMON_NOTIFICATIONS_LOAD",
  COMMON_NOTIFICATIONS_REMOVE = "COMMON_NOTIFICATIONS_REMOVE",
  COMMON_NOTIFICATIONS_PURGE = "COMMON_NOTIFICATIONS_PURGE",
  //common/activity_logs
  COMMON_ACTIVITY_LOGS_LOAD = "COMMON_ACTIVITY_LOGS_LOAD",
  //common/auth_checkpoints
  COMMON_AUTH_CHECKPOINTS_LOAD = "COMMON_AUTH_CHECKPOINTS_LOAD",
  COMMON_AUTH_CHECKPOINTS_TOGGLE = "COMMON_AUTH_CHECKPOINTS_TOGGLE",
  //common/auth
  COMMON_AUTH_LOGIN = "COMMON_AUTH_LOGIN",
  COMMON_AUTH_IFRAME_LOGIN = "COMMON_AUTH_IFRAME_LOGIN",
  COMMON_AUTH_REGISTER = "COMMON_AUTH_REGISTER",
  COMMON_AUTH_REFRESH_USER = "COMMON_AUTH_REFRESH_USER",
  COMMON_AUTH_LOGOUT = "COMMON_AUTH_LOGOUT",
  COMMON_AUTH_PASSWORD_FORGOT = "COMMON_AUTH_PASSWORD_FORGOT",
  COMMON_AUTH_PASSWORD_RESET = "COMMON_AUTH_PASSWORD_RESET",
  COMMON_AUTH_VERIFY = "COMMON_AUTH_VERIFY",
  COMMON_AUTH_INSTALL = "COMMON_AUTH_INSTALL",
  COMMON_AUTH_EXPIRES_REMINDER_SET = "COMMON_AUTH_EXPIRES_REMINDER_SET",
  COMMON_AUTH_REFRESH = "COMMON_AUTH_REFRESH",
  COMMON_AUTH_LOGIN_AS_USER = "COMMON_AUTH_LOGIN_AS_USER",
  COMMON_AUTH_RETURN_TO_ADMIN = "COMMON_AUTH_RETURN_TO_ADMIN",
  COMMON_AUTH_LOGIN_FROM_LEGACY = "COMMON_AUTH_LOGIN_FROM_LEGACY",
  COMMON_AUTH_LOGIN_FROM_FLEX_PSP = "COMMON_AUTH_LOGIN_FROM_FLEX_PSP",
  COMMON_AUTH_LOGIN_FROM_REMOTE_PORTAL = "COMMON_AUTH_LOGIN_FROM_REMOTE_PORTAL",
  COMMON_AUTH_LOGIN_TO_LEGACY = "COMMON_AUTH_LOGIN_TO_LEGACY",
  COMMON_AUTH_APPROVE_EMAIL = "COMMON_AUTH_APPROVE_EMAIL",
  COMMON_AUTH_GET_AFFILIATE_OWNER = "COMMON_AUTH_GET_AFFILIATE_OWNER",
  //common/user
  COMMON_USER_UPDATE = "COMMON_USER_UPDATE",
  COMMON_USER_COMPANY_SET = "COMMON_USER_COMPANY_SET",
  COMMON_USER_AVATAR_UPDATE = "COMMON_USER_AVATAR_UPDATE",
  COMMON_USER_PASSWORD_UPDATE = "COMMON_USER_PASSWORD_UPDATE",
  COMMON_USER_TFA_REMOVE = "COMMON_USER_TFA_REMOVE",
  COMMON_USER_TFA_SET = "COMMON_USER_TFA_SET",
  COMMON_USER_PULL = "COMMON_USER_PULL",
  //common/dictionary
  COMMON_DICTIONARY_COUNTRIES_LOAD = "COMMON_DICTIONARY_COUNTRIES_LOAD",
  COMMON_DICTIONARY_COMPANY_INDUSTRIES_LOAD = "COMMON_DICTIONARY_COMPANY_INDUSTRIES_LOAD",
  COMMON_DICTIONARY_ONBOARDING_STAGES_LOAD = "COMMON_DICTIONARY_ONBOARDING_STAGES_LOAD",
  COMMON_DICTIONARY_EMPLOYEE_BUSINESS_ROLES_LOAD = "COMMON_DICTIONARY_EMPLOYEE_BUSINESS_ROLES_LOAD",
  COMMON_DICTIONARY_USER_DOCUMENT_TYPES_LOAD = "COMMON_DICTIONARY_USER_DOCUMENT_TYPES_LOAD",
  COMMON_DICTIONARY_USER_ROLES_LOAD = "COMMON_DICTIONARY_USER_ROLES_LOAD",
  COMMON_DICTIONARY_COMPANY_PAYMENT_SERVICE_STATUSES_LOAD = "COMMON_DICTIONARY_COMPANY_PAYMENT_SERVICE_STATUSES_LOAD",
  COMMON_DICTIONARY_COMPANY_PAYMENT_SERVICES_LOAD = "COMMON_DICTIONARY_COMPANY_PAYMENT_SERVICES_LOAD",
  COMMON_DICTIONARY_CORPORATION_TYPES_LOAD = "COMMON_DICTIONARY_CORPORATION_TYPES_LOAD",
  COMMON_DICTIONARY_CRYPTO_NETWORKS_LOAD = "COMMON_DICTIONARY_CRYPTO_NETWORKS_LOAD",
  COMMON_DICTIONARY_COMPANY_FEATURES_LOAD = "COMMON_DICTIONARY_COMPANY_FEATURES_LOAD",
  COMMON_DICTIONARY_PORTAL_SERVICES_LOAD = "COMMON_DICTIONARY_PORTAL_SERVICES_LOAD",
  COMMON_DICTIONARY_CURRENCIES_LOAD = "COMMON_DICTIONARY_CURRENCIES_LOAD",
  COMMON_DICTIONARY_FIAT_CURRENCIES_LOAD = "COMMON_DICTIONARY_FIAT_CURRENCIES_LOAD",
  COMMON_DICTIONARY_CRYPTO_CURRENCIES_LOAD = "COMMON_DICTIONARY_CRYPTO_CURRENCIES_LOAD",
  COMMON_WEBSOCKETS_INITIATE = "COMMON_WEBSOCKETS_INITIATE",
  COMMON_WEBSOCKETS_CLOSE = "COMMON_WEBSOCKETS_CLOSE",
  //rates
  COMMON_RATES_REFRESH = "COMMON_RATES_REFRESH",
  COMMON_RATES_START = "COMMON_RATES_START",
  COMMON_RATES_STOP_INTERVAL = "COMMON_RATES_STOP_INTERVAL",
  COMMON_RATES_STOP_INTERVAL_BY_ID = "COMMON_RATES_STOP_INTERVAL_BY_ID",
  COMMON_RESET = "COMMON_RESET",

  GUEST_DICTIONARY_COUNTRIES_LOAD = "GUEST_DICTIONARY_COUNTRIES_LOAD",
  COMMON_ZOHO_APP_AUTHENTICATE = "COMMON_ZOHO_APP_AUTHENTICATE",
}

enum Mutations {
  //theme
  THEME_CLASSNAME_BY_POSITION_SET = "THEME_CLASSNAME_BY_POSITION_SET",
  THEME_BREADCRUMB_ACTION_SET = "THEME_BREADCRUMB_ACTION_SET",
  THEME_LAYOUT_CONFIG_SET = "THEME_LAYOUT_CONFIG_SET",
  THEME_LAYOUT_CONFIG_RESET = "THEME_LAYOUT_CONFIG_RESET",
  THEME_LAYOUT_CONFIG_OVERRIDE = "THEME_LAYOUT_CONFIG_OVERRIDE",
  THEME_WHITE_LABEL_SET = "THEME_WHITE_LABEL_SET",
  //admin
  ADMIN_TRANSACTION_STATISTIC_SET = "ADMIN_TRANSACTION_STATISTIC_SET",
  ADMIN_TIMELINE_ENTITY_CLASSES_SET = "ADMIN_TIMELINE_ENTITY_CLASSES_SET",
  ADMIN_USER_STATISTIC_SET = "ADMIN_USER_STATISTIC_SET",
  ADMIN_AUTH_CHECKPOINTS_SET = "ADMIN_AUTH_CHECKPOINTS_SET",
  ADMIN_AUTH_CHECKPOINTS_RESET = "ADMIN_AUTH_CHECKPOINTS_RESET",
  ADMIN_AUTH_CHECKPOINTS_SET_LOADING = "ADMIN_AUTH_CHECKPOINTS_SET_LOADING",
  ADMIN_USERS_SET = "ADMIN_USERS_SET",
  ADMIN_USERS_RESET = "ADMIN_USERS_RESET",
  ADMIN_USERS_OVERRIDE = "ADMIN_USERS_OVERRIDE",
  ADMIN_USERS_ROLES_OVERRIDE = "ADMIN_USERS_ROLES_OVERRIDE",
  ADMIN_USERS_SET_LOADING = "ADMIN_USERS_SET_LOADING",
  ADMIN_USER_UPDATE = "ADMIN_USER_UPDATE",
  ADMIN_USER_AVATAR_UPDATE = "ADMIN_USER_AVATAR_UPDATE",
  ADMIN_COMPANIES_SET = "ADMIN_COMPANIES_SET",
  ADMIN_COMPANIES_RESET = "ADMIN_COMPANIES_RESET",
  ADMIN_COMPANIES_SET_LOADING = "ADMIN_COMPANIES_SET_LOADING",
  ADMIN_BANK_ACCOUNTS_SET = "ADMIN_BANK_ACCOUNTS_SET",
  ADMIN_BANK_ACCOUNTS_RESET = "ADMIN_BANK_ACCOUNTS_RESET",
  ADMIN_BANK_ACCOUNTS_SET_LOADING = "ADMIN_BANK_ACCOUNTS_SET_LOADING",
  ADMIN_BANK_ACCOUNT_INTEGRITIES_SET = "ADMIN_BANK_ACCOUNT_INTEGRITIES_SET",
  ADMIN_SETTINGS_SET = "ADMIN_SETTINGS_SET",
  ADMIN_SETTINGS_SET_LOADING = "ADMIN_SETTINGS_SET_LOADING",
  ADMIN_BANK_ACCOUNT_INTEGRITIES_SET_LOADING = "ADMIN_BANK_ACCOUNT_INTEGRITIES_SET_LOADING",
  ADMIN_SYSTEM_OVERVIEW_SET = "ADMIN_SYSTEM_OVERVIEW_SET",
  ADMIN_SYSTEM_OVERVIEW_SET_INTERVAL = "ADMIN_SYSTEM_OVERVIEW_SET_INTERVAL",
  ADMIN_SYSTEM_STATISTIC_TRANSACTION_VOLUME_SET = "ADMIN_SYSTEM_STATISTIC_TRANSACTION_VOLUME_SET",
  ADMIN_ANNOUNCEMENTS_SET_LOADING = "ADMIN_ANNOUNCEMENTS_SET_LOADING",
  ADMIN_ANNOUNCEMENTS_REPLACE = "ADMIN_ANNOUNCEMENTS_REPLACE",
  ADMIN_ANNOUNCEMENTS_REMOVE = "ADMIN_ANNOUNCEMENTS_REMOVE",
  ADMIN_ANNOUNCEMENTS_SET = "ADMIN_ANNOUNCEMENTS_SET",
  ADMIN_ANNOUNCEMENTS_RESET = "ADMIN_ANNOUNCEMENTS_RESET",
  //manager
  MANAGER_TICKETS_TOGGLE_STATE = "MANAGER_TICKETS_TOGGLE_STATE",
  MANAGER_COMPANY_WHITE_LABEL_SET = "MANAGER_COMPANY_WHITE_LABEL_SET",
  MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_SET = "MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_SET",
  MANAGER_COMPANY_STATISTIC_SET = "MANAGER_COMPANY_STATISTIC_SET",
  MANAGER_COMPANY_STATISTIC_RESET = "MANAGER_COMPANY_STATISTIC_RESET",
  MANAGER_COMPANY_STATISTIC_TRANSACTION_VOLUME_SET = "MANAGER_COMPANY_STATISTIC_TRANSACTION_VOLUME_SET",
  MANAGER_COMPANY_STATISTIC_ACCOUNTS_VOLUME_SET = "MANAGER_COMPANY_STATISTIC_ACCOUNTS_VOLUME_SET",
  MANAGER_COMPANY_ACCOUNTS_SET = "MANAGER_COMPANY_ACCOUNTS_SET",
  MANAGER_COMPANY_ACCOUNTS_RESET = "MANAGER_COMPANY_ACCOUNTS_RESET",
  MANAGER_COMPANY_ACCOUNT_REPLACE = "MANAGER_COMPANY_ACCOUNT_REPLACE",
  MANAGER_COMPANY_ACCOUNT_REPLACE_OR_ADD = "MANAGER_COMPANY_ACCOUNT_REPLACE_OR_ADD",
  MANAGER_COMPANY_ACCOUNT_SELECT = "MANAGER_COMPANY_ACCOUNT_SELECT",
  MANAGER_COMPLIANCE_TRACKINGS_SET = "MANAGER_COMPLIANCE_TRACKINGS_SET",
  MANAGER_COMPLIANCE_TRACKINGS_RESET = "MANAGER_COMPLIANCE_TRACKINGS_RESET",
  MANAGER_COMPLIANCE_TRACKINGS_FILE_REPLACE = "MANAGER_COMPLIANCE_TRACKINGS_FILE_REPLACE",
  MANAGER_COMPLIANCE_TRACKINGS_REPLACE = "MANAGER_COMPLIANCE_TRACKINGS_REPLACE",
  MANAGER_ANNOUNCEMENTS_SET_LOADING = "MANAGER_ANNOUNCEMENTS_SET_LOADING",
  MANAGER_ANNOUNCEMENTS_SET = "MANAGER_ANNOUNCEMENTS_SET",
  MANAGER_ANNOUNCEMENTS_RESET = "MANAGER_ANNOUNCEMENTS_RESET",
  MANAGER_AFFILIATE_COMPANIES_SET_LOADING = "MANAGER_AFFILIATE_COMPANIES_SET_LOADING",
  MANAGER_WHITE_LABELED_COMPANIES_SET_LOADING = "MANAGER_WHITE_LABELED_COMPANIES_SET_LOADING",
  MANAGER_COMPANY_PRODUCTS_SET_LOADING = "MANAGER_COMPANY_PRODUCTS_SET_LOADING",
  MANAGER_COMPANY_WALLETS_SET_LOADING = "MANAGER_COMPANY_WALLETS_SET_LOADING",
  MANAGER_AFFILIATE_COMPANIES_SET = "MANAGER_AFFILIATE_COMPANIES_SET",
  MANAGER_WHITE_LABELED_COMPANIES_SET = "MANAGER_WHITE_LABELED_COMPANIES_SET",
  MANAGER_AFFILIATE_COMPANIES_RESET = "MANAGER_AFFILIATE_COMPANIES_RESET",
  MANAGER_WHITE_LABELED_COMPANIES_RESET = "MANAGER_WHITE_LABELED_COMPANIES_RESET",
  MANAGER_COMPANY_PRODUCTS_SET = "MANAGER_COMPANY_PRODUCTS_SET",
  MANAGER_COMPANY_PRODUCTS_RESET = "MANAGER_COMPANY_PRODUCTS_RESET",
  MANAGER_COMPANY_WALLETS_SET = "MANAGER_COMPANY_WALLETS_SET",
  MANAGER_COMPANY_WALLETS_RESET = "MANAGER_COMPANY_WALLETS_RESET",
  MANAGER_PORTAL_SERVICE_SET_REMOTE_ACCOUNTS = "MANAGER_PORTAL_SERVICE_SET_REMOTE_ACCOUNTS",
  MANAGER_OPENAI_CHAT_HISTORY_SET_LOADING = "MANAGER_OPENAI_CHAT_HISTORY_SET_LOADING",
  MANAGER_OPENAI_CHAT_HISTORY_SET = "MANAGER_OPENAI_CHAT_HISTORY_SET",
  MANAGER_OPENAI_CHAT_HISTORY_ADD_MESSAGE = "MANAGER_OPENAI_CHAT_HISTORY_ADD_MESSAGE",
  MANAGER_OPENAI_CHAT_HISTORY_UPDATE_MESSAGE = "MANAGER_OPENAI_CHAT_HISTORY_UPDATE_MESSAGE",
  MANAGER_PSP_PORTAL_ACCOUNTS_SET = "MANAGER_PSP_PORTAL_ACCOUNTS_SET",
  //common
  COMMON_AUTH_PURGE = "COMMON_AUTH_PURGE",
  COMMON_AUTH_ADMIN_TOKEN_PURGE = "COMMON_AUTH_ADMIN_TOKEN_PURGE",
  COMMON_AUTH_ADMIN_TOKEN_SET = "COMMON_AUTH_ADMIN_TOKEN_SET",
  COMMON_AUTH_SET = "COMMON_AUTH_SET",
  COMMON_USER_SET = "COMMON_USER_SET",
  COMMON_COMPANY_ALERTS_SET = "COMMON_COMPANY_ALERTS_SET",
  COMMON_WEBSOCKETS_ECHO_SET = "COMMON_WEBSOCKETS_ECHO_SET",
  COMMON_USER_SETTINGS_UPDATE = "COMMON_USER_SETTINGS_UPDATE",
  COMMON_AUTH_EXPIRES_REMINDER_SET_INTERVAL = "COMMON_AUTH_EXPIRES_REMINDER_SET_INTERVAL",
  COMMON_AUTH_TFA_CODE_SET = "COMMON_AUTH_TFA_CODE_SET",
  COMMON_AUTH_TFA_CODE_SET_ERROR = "COMMON_AUTH_TFA_CODE_SET_ERROR",
  COMMON_AUTH_TFA_CODE_SET_SUBMITTING = "COMMON_AUTH_TFA_CODE_SET_SUBMITTING",
  COMMON_AUTH_TFA_CODE_CHANGE_STATE = "COMMON_AUTH_TFA_CODE_CHANGE_STATE",
  COMMON_AUTH_TFA_CODE_CHANGE_CANCELED = "COMMON_AUTH_TFA_CODE_CHANGE_CANCELED",
  COMMON_NOTIFICATIONS_SET = "COMMON_NOTIFICATIONS_SET",
  COMMON_NOTIFICATIONS_RESET = "COMMON_NOTIFICATIONS_RESET",
  COMMON_ACTIVITY_LOGS_SET = "COMMON_ACTIVITY_LOGS_SET",
  COMMON_ACTIVITY_RESET = "COMMON_ACTIVITY_RESET",
  COMMON_ACTIVITY_LOGS_SET_LOADING = "COMMON_ACTIVITY_LOGS_SET_LOADING",
  COMMON_DICTIONARY_SET_COUNTRIES = "COMMON_DICTIONARY_SET_COUNTRIES",
  COMMON_DICTIONARY_SET_COMPANY_FEATURES = "COMMON_DICTIONARY_SET_COMPANY_FEATURES",
  COMMON_DICTIONARY_SET_COMPANY_INDUSTRIES = "COMMON_DICTIONARY_SET_COMPANY_INDUSTRIES",
  COMMON_DICTIONARY_SET_ONBOARDING_STAGES = "COMMON_DICTIONARY_SET_ONBOARDING_STAGES",
  COMMON_DICTIONARY_SET_EMPLOYEE_BUSINESS_ROLES = "COMMON_DICTIONARY_SET_EMPLOYEE_BUSINESS_ROLES",
  COMMON_DICTIONARY_SET_USER_DOCUMENT_TYPES = "COMMON_DICTIONARY_SET_USER_DOCUMENT_TYPES",
  COMMON_DICTIONARY_SET_USER_ROLES = "COMMON_DICTIONARY_SET_USER_ROLES",
  COMMON_DICTIONARY_SET_PAYMENT_SERVICE_STATUSES = "COMMON_DICTIONARY_SET_PAYMENT_SERVICE_STATUSES",
  COMMON_DICTIONARY_SET_COMPANY_PAYMENT_SERVICES = "COMMON_DICTIONARY_SET_COMPANY_PAYMENT_SERVICES",
  COMMON_DICTIONARY_SET_CORPORATION_TYPES = "COMMON_DICTIONARY_SET_CORPORATION_TYPES",
  COMMON_DICTIONARY_SET_CRYPTO_NETWORKS = "COMMON_DICTIONARY_SET_CRYPTO_NETWORKS",
  COMMON_DICTIONARY_SET_PORTAL_SERVICES = "COMMON_DICTIONARY_SET_PORTAL_SERVICES",
  COMMON_DICTIONARY_SET_FIAT_CURRENCIES = "COMMON_DICTIONARY_SET_FIAT_CURRENCIES",
  COMMON_DICTIONARY_SET_CRYPTO_CURRENCIES = "COMMON_DICTIONARY_SET_CRYPTO_CURRENCIES",
  COMMON_DICTIONARY_PURGE = "COMMON_DICTIONARY_PURGE",
  //rates
  COMMON_RATES_SETUP_STATE = "COMMON_RATES_SETUP_STATE",
  COMMON_RATES_CHANGE_STATE_VALUE = "COMMON_RATES_CHANGE_STATE_VALUE",
  COMMON_RATES_TIMER_TAP = "COMMON_RATES_TIMER_TAP",
  COMMON_RATES_TIMER_REFRESH = "COMMON_RATES_TIMER_REFRESH",
  COMMON_RATES_LOADING = "COMMON_RATES_LOADING",
  COMMON_REQUEST_DONE = "COMMON_REQUEST_DONE",
  COMMON_REQUEST_STATS_RESET = "COMMON_REQUEST_STATS_RESET",
  COMMON_IFRAME_SET_PAGE_LOAD_INFO = "COMMON_IFRAME_SET_PAGE_LOAD_INFO",
}

export { Actions, Mutations };
